.button {
    appearance: none;
    display: block;
    width: 34px;
    height: 34px;
    padding: 2px;
    border: 0;
    border-radius: 4px;
    background: var(--ui-bg-color);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);
    cursor: pointer;

    &:hover {
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
    }

    &:active {
        box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);
    }

    &:focus-visible {
        outline: 2px solid var(--active-highlight-color);
        outline-offset: 2px;
    }
}

.color {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 3px;
    pointer-events: none;
}

:global(:root.kl-theme-dark) {
    .button {
        background: var(--ui-bg-dark);
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3);

        &:hover {
            box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);
        }

        &:active {
            box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
        }
    }
}
